import React from "react";
import { CalendarDays, CheckCircle2, Info } from "lucide-react";
import { tariefs, serviceArea } from "../mock";
import { useBooking } from "../context/BookingContext";

const Tarieven = () => {
  const booking = useBooking();

  const cards = [
    { key: "particulier", title: "Reparatie — Particulier", ...tariefs.particulier, featured: true },
    { key: "zakelijk", title: "Reparatie — Zakelijk / MKB", ...tariefs.zakelijk },
    { key: "remoteParticulier", title: "Hulp op afstand — Particulier", ...tariefs.remoteParticulier },
    { key: "remoteZakelijk", title: "Hulp op afstand — Zakelijk", ...tariefs.remoteZakelijk },
  ];

  return (
    <section className="py-20 bg-neutral-50">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">
            — Tarieven
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-5 leading-tight">
            Eerlijk &amp; transparant,
            <br />
            <span className="italic font-light">zonder verrassingen.</span>
          </h2>
          <p className="text-lg text-neutral-600 leading-relaxed">
            Duidelijke uurtarieven en vooraf altijd een prijsopgave. Geen voorrijkosten
            binnen regio IJmond.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-neutral-200 bg-white">
          {cards.map((c) => (
            <div
              key={c.key}
              className={`p-8 border-r border-b border-neutral-200 flex flex-col ${
                c.featured ? "bg-neutral-900 text-white" : "bg-white"
              }`}
            >
              <p
                className={`text-xs uppercase tracking-[0.25em] mb-4 ${
                  c.featured ? "text-neutral-400" : "text-neutral-500"
                }`}
              >
                {c.title}
              </p>
              <div className="mb-6">
                <span
                  className={`text-5xl font-bold ${c.featured ? "text-white" : "text-neutral-900"}`}
                >
                  {c.hourly}
                </span>
                <p
                  className={`text-sm mt-2 ${c.featured ? "text-neutral-400" : "text-neutral-500"}`}
                >
                  {c.label}
                </p>
                {c.per15 && (
                  <p className={`text-xs mt-1 font-medium ${c.featured ? "text-amber-300" : "text-neutral-700"}`}>
                    of <span className="font-bold">{c.per15}</span> per 15 minuten
                  </p>
                )}
              </div>
              <p
                className={`text-sm mb-6 leading-relaxed flex-1 ${
                  c.featured ? "text-neutral-300" : "text-neutral-600"
                }`}
              >
                {c.note}
              </p>
              <ul
                className={`space-y-2 mb-7 text-sm ${
                  c.featured ? "text-neutral-300" : "text-neutral-700"
                }`}
              >
                <li className="flex items-center gap-2">
                  <CheckCircle2
                    size={14}
                    className={c.featured ? "text-emerald-400" : "text-emerald-600"}
                  />
                  Gratis diagnose &amp; vrijblijvende prijsopgave
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2
                    size={14}
                    className={c.featured ? "text-emerald-400" : "text-emerald-600"}
                  />
                  3 maanden garantie op reparaties
                </li>
              </ul>
              <button
                onClick={booking.open}
                className={`w-full inline-flex items-center justify-center gap-2 px-5 py-3 text-sm font-medium transition-colors ${
                  c.featured
                    ? "bg-white text-neutral-900 hover:bg-neutral-100"
                    : "bg-neutral-900 text-white hover:bg-black"
                }`}
              >
                <CalendarDays size={15} />
                Maak een afspraak
              </button>
            </div>
          ))}
        </div>

        {/* Service area */}
        <div className="mt-10 bg-white border border-neutral-200 p-6 md:p-8 flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-neutral-900 text-white flex items-center justify-center flex-shrink-0">
              <Info size={18} />
            </div>
            <div>
              <p className="text-sm font-semibold text-neutral-900 mb-0.5">
                Geen voorrijkosten in regio IJmond
              </p>
              <p className="text-sm text-neutral-600">
                Wij komen kosteloos aan huis in Beverwijk en omgeving.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 lg:ml-auto">
            {serviceArea.map((city) => (
              <span
                key={city}
                className="text-xs bg-neutral-100 text-neutral-700 px-3 py-1.5 rounded-full border border-neutral-200"
              >
                {city}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tarieven;
